export const calculateBarValue = (count: number, total: number) => {
    const share = total !== 0 ? (count / total) * 100 : 0;
    return share === 0 ? 100 : share;
};
